import { useEffect, useState } from "react";
import { fetchDistricts, downloadDistrictsExcel } from "../Api/ViewDistrictMaster";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewDistrictMaster = () => {
  const [districts, setDistricts] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const data = await fetchDistricts();
        setDistricts(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Districts`);
      }
    };

    loadDistricts();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadDistrictsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Districts_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Districts data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="">
          <Container  className="list-container">
             <div className="header-background">
              <h2 className="header-list-title">View Districts</h2>
              <Button className="gradient-btn"
                // variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || districts.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {districts.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>District ID</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Country</th>
                    <th>Region</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {districts.map((district, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{district.districtId}</td>
                      <td>{district.code}</td>
                      <td>{district.description}</td>
                      <td>{district.country}</td>
                      <td>{district.region}</td>
                      <td>
                        {moment(district.createdOnDate).format('L')} at {district.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{district.createdBy}</td>
                      <td>
                        {district.changedOnDate ? 
                          `${moment(district.changedOnDate).format('L')} at ${district.changedOnTime?.substring(0, 8)}` 
                          : 'N/A'}
                      </td>
                      <td>{district.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No districts found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewDistrictMaster;